import React from "react";
import { BsSearch } from "react-icons/bs";
import { NavLink, Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <header className="header-top-strip py-3">
        <div className="container-xxl">
          <div className="row">
            <div className="col-6">
              <p className="text-white mb-0">
                Free shipping Over $100 & Free Returns
              </p>
            </div>
            <div className="col-6">
              <p className="text-end  text-white mb-0">
                Hotline:
                <a className="text-white" href="tel: +91 9936738846">
                  +91 9936738846
                </a>
              </p>
            </div>
          </div>
        </div>
      </header>

      <header className="header-upper">
        <div className="container-xxl">
          <div className="row  align-items-center">
            <div className="col-2">
              <h1>
                {/* <Link className="text-white">Ecommerce</Link> */}
                <img src="R.png" alt="not found" />
              </h1>
            </div>
            <div className="col-5">
              <div className="input-group  mb-1">
                <input
                  type="text"
                  className="form-control py-2"
                  placeholder="Search Product Here...."
                  aria-label="Search Product Here...."
                  aria-describedby="basic-addon2"
                ></input>
                <span className="input-group-text p-3" id="basic-addon2">
                  <BsSearch className="fs-6" />
                </span>
              </div>
            </div>
            <div className="col-5">
              <div className="header-upper-links d-flex  align-items-center justify-content-between">
                <div>
                  <Link
                    to="/compare-products"
                    className="d-flex align-items-center gap-10 text-white"
                  >
                    <img src="images/compare.svg" alt="404NF"></img>
                    <p className="mb-0">
                      Compare <br /> Products
                    </p>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/wishlist "
                    className="d-flex align-items-center gap-10 text-white"
                  >
                    <img src="images/wishlist.svg" alt="404NF"></img>
                    <p className="mb-0">
                      Favourite <br /> Product
                    </p>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/login"
                    className="d-flex align-items-center gap-10 text-white"
                  >
                    <img src="images/user.svg" alt="404NF"></img>
                    <p className="mb-0">
                      Login <br /> MY Account
                    </p>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/cart"
                    className="d-flex align-items-center gap-10 text-white"
                  >
                    <img src="images/cart.svg" alt="404NF" />
                    <div className=" d-flex flex-column gap-10 mb-0">
                      <span className="badge bg-white text-dark mb-0">0</span>
                      <p className="mb-0">$ 500</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <header className="header-down py-3">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <div className="menu-down d-flex align-items-center gap-30">
                <div>
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle bg-transparent border-0 gap-15  d-flex align-items-center"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src="images/menu.svg" alt="menu404"></img>
                      <span className="me-5 d-inline-block">
                        Shop Categoriess
                      </span>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <Link className="dropdown-item text-white" to="">
                          Action
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-white" to="">
                          Another action
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-white" to="">
                          Something else here
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="menu-links">
                  <div className="d-flex align-align-items-center gap-15">
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="product_store">Our Store</NavLink>
                    <NavLink to="blogs">Blog</NavLink>
                    <NavLink to="contacts">Contact</NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
